"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientId = void 0;
/**
 * Returns a clientId if the provided clientId is defined, optionally appending a suffix.
 * This is used to generate client ids for multiple unique portions of a component
 * based on a provided clientId.
 */
const getClientId = (clientId, append) => {
  if (!clientId) return undefined;
  return [clientId, append].filter(Boolean).join("-");
};
exports.getClientId = getClientId;
//# sourceMappingURL=getClientId.js.map